if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      if (this.cartTermsCheckbox && localStorage.getItem('cartTermsAccepted') === 'true') {
        this.cartTermsCheckbox.checked = true;
      }
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.addEventListener("change", this.changeHandler.bind(this));
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
      }
    }

    /**
     * Handles checkbox change
     */
    changeHandler() {
      if (this.cartTermsCheckbox.checked) {
        localStorage.setItem('cartTermsAccepted', 'true');
      } else {
        localStorage.removeItem('cartTermsAccepted');
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}
